import { studentBookingClient } from '../client';

import { RoomServiceEndpoints } from './constants';
import { RoomInfoDto } from './dto/RoomInfoDto';
import {
    PostRoomInfoSuccessResponse,
    RoomInfoRequest,
    GetRoomAvailabilitySuccessResponse,
    RoomAvailabilityRequest,
    RoomType,
} from './types';

export const getRoomAvailability = async (body: RoomAvailabilityRequest): Promise<RoomType[]> => {
    const { data: response } = await studentBookingClient.post<GetRoomAvailabilitySuccessResponse>(
        RoomServiceEndpoints.GetRoomAvailability,
        body
    );

    return response.data;
};

export const getRoomInfo = async (roomInfoRequest: RoomInfoRequest): Promise<RoomInfoDto> => {
    const { data: response } = await studentBookingClient.post<PostRoomInfoSuccessResponse>(
        RoomServiceEndpoints.PostRoomInfo,
        roomInfoRequest
    );

    return new RoomInfoDto(response.data);
};
